// api.js
import config from './config';

export const fetchBackendData = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api`);
    return await response.json();
  } catch (error) {
    return { error: 'Verbindung fehlgeschlagen' };
  }
};

// API-Funktionen für Schuljahre
export const fetchSchuljahre = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/schuljahre`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Schuljahre' };
  }
};

export const fetchCurrentSchuljahr = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/schuljahre/current`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des aktuellen Schuljahres' };
  }
};

// API-Funktion für Klassen
export const fetchKlassen = async (schuljahrId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/klassen?schuljahrId=${schuljahrId}`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Klassen' };
  }
};

// API-Funktionen für Lernende
export const fetchLernendeBySchuljahrId = async (schuljahrId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/lernende/schuljahr/${schuljahrId}`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Lernenden' };
  }
};

export const fetchLernendeByKlassenId = async (klassenId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/lernende/klasse/${klassenId}`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Lernenden' };
  }
};

// API-Funktionen für Moodle Badges
export const fetchMoodleBadges = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/moodle/badges`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Badges' };
  }
};

export const fetchUserBadgeAwards = async (badgeIds = null) => {
  try {
    let url = `${config.API_HOST}:${config.API_PORT}/api/moodle/user-badge-awards`;
    
    if (badgeIds && badgeIds.length > 0) {
      const badgeIdsParam = Array.isArray(badgeIds) ? badgeIds.join(',') : badgeIds;
      url += `?badgeIds=${encodeURIComponent(badgeIdsParam)}`;
    }
    
    const response = await fetch(url, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Badge-Zuweisungen' };
  }
};

export const testMoodleConnection = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/moodle/test-connection`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Testen der Moodle-Verbindung' };
  }
};

// Authentifizierungs-API-Funktionen
export const checkLogin = async (username, password) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/checkLogin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY
      },
      body: JSON.stringify({ username, password })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Login fehlgeschlagen');
    }
    
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const checkAuth = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/checkAuth`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    return await response.json();
  } catch (error) {
    return { success: false, error: 'Authentifizierungsprüfung fehlgeschlagen' };
  }
};

export const logout = async () => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/logout`, {
      method: 'POST',
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    return await response.json();
  } catch (error) {
    return { success: false, error: 'Logout fehlgeschlagen' };
  }
};

// API-Funktionen für Pläne
export const fetchUserPlans = async (userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Pläne' };
  }
};

export const fetchPlan = async (planId, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des Plans' };
  }
};

export const savePlan = async (userId, name, description, data, baseName = null, sourcePlan = null) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify({
        name,
        description,
        data,
        baseName,
        sourcePlan
      })
    });
    
    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        }
      } catch (e) {
        // Falls JSON-Parsing fehlschlägt, verwende Standard-Fehlermeldung
      }
      return { error: errorMessage };
    }
    
    return await response.json();
  } catch (error) {
    console.error('savePlan network error:', error);
    // Unterscheide zwischen verschiedenen Fehlertypen
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      return { error: 'Backend nicht erreichbar - Bitte prüfen Sie Ihre Internetverbindung und ob der Server läuft.' };
    } else if (error.name === 'AbortError') {
      return { error: 'Anfrage wurde abgebrochen - Timeout erreicht.' };
    } else {
      return { error: error.message || 'Unbekannter Fehler beim Speichern des Plans' };
    }
  }
};

export const updatePlan = async (planId, userId, name, description, data) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify({
        name,
        description,
        data
      })
    });
    
    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        }
      } catch (e) {
        // Falls JSON-Parsing fehlschlägt, verwende Standard-Fehlermeldung
      }
      return { error: errorMessage };
    }
    
    return await response.json();
  } catch (error) {
    console.error('updatePlan network error:', error);
    // Unterscheide zwischen verschiedenen Fehlertypen
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      return { error: 'Backend nicht erreichbar - Bitte prüfen Sie Ihre Internetverbindung und ob der Server läuft.' };
    } else if (error.name === 'AbortError') {
      return { error: 'Anfrage wurde abgebrochen - Timeout erreicht.' };
    } else {
      return { error: error.message || 'Unbekannter Fehler beim Aktualisieren des Plans' };
    }
  }
};

export const deletePlan = async (planId, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}`, {
      method: 'DELETE',
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Löschen des Plans' };
  }
};

// API-Funktionen für Plan-Namen und Versionen
export const fetchPlanNames = async (userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plan-names`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Plan-Namen' };
  }
};

export const fetchPlanVersions = async (userId, baseName) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/versions/${encodeURIComponent(baseName)}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Plan-Versionen' };
  }
};

// API-Funktionen für Gruppen und Veröffentlichungen
export const fetchGroups = async (userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/groups`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Gruppen' };
  }
};

export const publishPlan = async (planId, groupIds, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}/publish`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify({ groupIds })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Veröffentlichen des Plans' };
  }
};

export const fetchPublishedPlans = async (userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/published-plans`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der veröffentlichten Pläne' };
  }
};

export const fetchPublishedPlanVersions = async (userId, baseName, planOwnerId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/published-plans/versions/${encodeURIComponent(planOwnerId)}/${encodeURIComponent(baseName)}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der veröffentlichten Plan-Versionen' };
  }
};

export const fetchPublishedPlan = async (planId, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/published-plans/${planId}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des veröffentlichten Plans' };
  }
};

export const fetchPlanPublicationStatus = async (planId, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}/publication-status`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des Veröffentlichungs-Status' };
  }
};

// Plan für Lernende freigeben/sperren
export const setStudentRelease = async (planId, released, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}/student-release`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify({ released })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Setzen der Lernenden-Freigabe' };
  }
};

// Status der Lernenden-Freigabe für einen Plan abfragen
export const fetchStudentReleaseStatus = async (planId, userId) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plans/${planId}/student-release-status`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des Lernenden-Freigabe-Status' };
  }
};

// API-Funktionen für Special Times
export const fetchSpecialTimes = async (userId = null) => {
  try {
    const headers = {
      'x-api-key': config.API_KEY
    };
    
    if (userId) {
      headers['x-user-id'] = userId;
    }
    
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/special-times`, {
      headers
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Special Times' };
  }
};

export const fetchSpecialTime = async (id) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/special-times/${id}`, {
      headers: {
        'x-api-key': config.API_KEY
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Special Time' };
  }
};

export const createSpecialTime = async (specialTime, userId = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': config.API_KEY
    };
    
    if (userId) {
      headers['x-user-id'] = userId;
    }
    
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/special-times`, {
      method: 'POST',
      headers,
      body: JSON.stringify(specialTime)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Erstellen der Special Time' };
  }
};

export const updateSpecialTime = async (id, specialTime, userId = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': config.API_KEY
    };
    
    if (userId) {
      headers['x-user-id'] = userId;
    }
    
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/special-times/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(specialTime)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Aktualisieren der Special Time' };
  }
};

export const deleteSpecialTime = async (id, userId = null) => {
  try {
    const headers = {
      'x-api-key': config.API_KEY
    };
    
    if (userId) {
      headers['x-user-id'] = userId;
    }
    
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/special-times/${id}`, {
      method: 'DELETE',
      headers
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Löschen der Special Time' };
  }
};

// API-Funktionen für Task-Lernende Zuordnungen
export const updateTaskAssignments = async (userId, planName, planVersion, taskUuid, lernendeData) => {
  try {
    const requestData = {
      planName,
      planVersion,
      taskUuid,
      lernendeData
    };

    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/task-assignments`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify(requestData)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API-Fehler:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Fehler beim Aktualisieren der Task-Zuordnungen:', error);
    return { error: 'Fehler beim Aktualisieren der Task-Zuordnungen' };
  }
};

export const addTaskAssignments = async (userId, planName, planVersion, taskUuid, lernendeData) => {
  try {
    const requestData = {
      planName,
      planVersion,
      taskUuid,
      lernendeData
    };

    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/task-assignments/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify(requestData)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API-Fehler:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Fehler beim Hinzufügen der Task-Zuordnungen:', error);
    return { error: 'Fehler beim Hinzufügen der Task-Zuordnungen' };
  }
};

export const fetchTaskAssignments = async (userId, taskUuid, planVersion) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/task-assignments/${encodeURIComponent(taskUuid)}/${planVersion}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Task-Zuordnungen' };
  }
};

export const removeTaskAssignment = async (userId, taskUuid, planVersion, lernendenLogin) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/task-assignments/${encodeURIComponent(taskUuid)}/${planVersion}/${encodeURIComponent(lernendenLogin)}`, {
      method: 'DELETE',
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Entfernen der Task-Zuordnung' };
  }
};

export const fetchPlanAssignments = async (userId, planName, planVersion) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plan-assignments/${encodeURIComponent(planName)}/${planVersion}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Plan-Zuordnungen' };
  }
};

export const deletePlanAssignments = async (userId, planName, planVersion) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/plan-assignments/${encodeURIComponent(planName)}/${planVersion}`, {
      method: 'DELETE',
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Löschen der Plan-Zuordnungen' };
  }
};

export const copyTaskAssignmentsToNewUUID = async (userId, planName, planVersion, sourceTaskUuid, targetTaskUuid) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/copy-task-assignments-new-uuid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.API_KEY,
        'x-user-id': userId
      },
      body: JSON.stringify({
        planName,
        planVersion,
        sourceTaskUuid,
        targetTaskUuid
      })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API-Fehler:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Fehler beim Kopieren der Task-Zuordnungen zu neuer UUID:', error);
    return { error: 'Fehler beim Kopieren der Task-Zuordnungen zu neuer UUID' };
  }
};

// API-Funktionen für Lernende-Pläne
export const fetchStudentPlans = async (studentLogin) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/student-plans`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': studentLogin
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden der Lernenden-Pläne' };
  }
};

export const fetchStudentPlan = async (planId, studentLogin) => {
  try {
    const response = await fetch(`${config.API_HOST}:${config.API_PORT}/api/student-plans/${planId}`, {
      headers: {
        'x-api-key': config.API_KEY,
        'x-user-id': studentLogin
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    return { error: 'Fehler beim Laden des Lernenden-Plans' };
  }
};